<template>
    <div class="container">
        <!-- <div>
      <van-button @click="getLastedResource">重新获取iconfont最新资源</van-button>
    </div> -->
        <div class="container-style">
            <div class="head">
                <van-swipe style="width: 100vw;max-width: 550px;" v-show="swipeShow" ref="swipe" :autoplay="4000"
                    indicator-color="white" :lazy-render="true" :stop-propagation="false">
                    <van-swipe-item v-for="(image, index) in images" :key="index">
                        <img v-show="show" v-lazy="image" width="100%" height="auto" />
                    </van-swipe-item>
                </van-swipe>

                <!-- <img src="../assets/head2.png" alt=""> -->
                <!-- <van-image :src="require('../assets/head2.png')" width="100%"> -->
                <!-- <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template> -->
                <!-- </van-image> -->
                <!-- <div class="v1">格力光储直柔系统</div>
        <div class="v2">Gree Light Storage Direct Flexible System</div>
        <div class="v3">
          <img src="../assets/v1.png" alt="">
          <span>光伏消纳、峰谷套利</span>
        </div>
        <div class="v4">
          <img src="../assets/v2.png" alt="">
          <span>清洁能源、直流直驱</span>
        </div> -->

            </div>
            <div class="form" id="anchor">
                <van-form>
                    <div style="margin-bottom: 18px;">
                        <van-cell-group style="margin: 0 22px;" inset :border="true">
                            <van-field required v-model="info.name" autofocus maxlength="4" label="姓名" placeholder="请输入"
                                input-align="right" @input="nameInput"></van-field>
                        </van-cell-group>
                        <div class="errShow" style="padding-left: 22px;padding-top: 2px;"
                            v-show="!isFirstInput && !info.name">请输入
                        </div>
                        <div class="errShow" style="padding-left: 22px;padding-top: 2px;"
                            v-show="info.name && errStatus">请输入正确格式
                        </div>
                    </div>
                    <div style="margin-bottom: 18px;">
                        <van-cell-group inset style="margin: 0 22px;">
                            <van-field required v-model="info.phone" autofocus type="tel" label="电话" placeholder="请输入"
                                input-align="right" @input="phoneInput" />
                        </van-cell-group>
                        <div class="errShow" style="padding-left: 22px;padding-top: 2px;"
                            v-show="!isFirstInput && !info.phone">请输入
                        </div>
                        <div class="errShow" style="padding-left: 22px;padding-top: 2px;"
                            v-show="info.phone && errPhoneStatus">
                            请输入正确格式</div>
                    </div>
                    <div style="margin-bottom: 18px;">
                        <van-cell-group inset style="margin: 0 22px;">
                            <van-field readonly required v-model="selectValue" is-link label="地区选择" placeholder="请选择省市区"
                                input-align="right" @click="showArea = true" />
                        </van-cell-group>
                        <div class="errShow" style="padding-left: 22px;padding-top: 2px;"
                            v-show="!isFirstInput && !selectValue">
                            选择省市区
                        </div>
                    </div>

                    <div class="radio">
                        <div class="floorAreaChang">
                            <div class="title" style="padding-top: 0;">
                                <span class="radio-name">物业类别</span>
                                <div class="errShow" v-show="!isFirstInput && !info.propertyType">请至少选择一项</div>
                            </div>

                            <div class="option">
                                <van-radio-group v-model="value1" direction="horizontal"
                                    @change="change($event, 'propertyType')">
                                    <van-radio icon-size="18px" v-for="(item, index) in propertyTypeList" :key="index"
                                        :name="index" class="radio-group-item">{{ item }}</van-radio>
                                </van-radio-group>
                            </div>
                        </div>
                        <div class="floor">
                            <div class="title">
                                <span class="radio-name">楼层</span>
                                <div class="errShow" v-show="!isFirstInput && !info.floor">请至少选择一项</div>
                            </div>

                            <div class="option">
                                <van-radio-group v-model="value2" direction="horizontal"
                                    @change="change($event, 'floor')">
                                    <van-radio icon-size="18px" v-for="(item, index) in floorList" :key="index"
                                        :name="index" class="radio-group-item">{{
                                            item }}</van-radio>
                                    <van-radio name="other" icon-size="18px" class="radio-group-item">
                                        <div class="other">
                                            <span>其他</span>
                                            <van-field v-model="inputvalue" class="otherInput"
                                                @input="inputValueChange($event, 'floor')" />
                                        </div>

                                    </van-radio>
                                </van-radio-group>
                            </div>
                        </div>

                        <div class="floorArea">
                            <div class="title">
                                <span class="radio-name">每层面积</span>
                                <div class="errShow" v-show="!isFirstInput && !info.floorArea">请至少选择一项</div>
                            </div>

                            <div class="option">
                                <van-radio-group v-model="value3" direction="horizontal"
                                    @change="change($event, 'floorArea')">
                                    <van-radio icon-size="18px" v-for="(item, index) in floorAreaList" :key="index"
                                        :name="index" class="radio-group-item">{{
                                            item }}</van-radio>
                                    <van-radio name="other" icon-size="18px" class="radio-group-item">
                                        <div class="other">
                                            <span>其他</span>
                                            <van-field v-model="floorAreaVal" class="otherInput"
                                                @input="inputValueChange($event, 'floorArea')" />
                                        </div>
                                    </van-radio>
                                </van-radio-group>

                            </div>
                        </div>
                        <div class="roofType">
                            <div class="title">
                                <span class="radio-name">屋顶类型</span>
                                <div class="errShow" v-show="!isFirstInput && !info.roofType">请至少选择一项</div>
                            </div>

                            <div class="option">
                                <van-radio-group v-model="value4" direction="horizontal"
                                    @change="change($event, 'roofType')">
                                    <van-radio icon-size="18px" v-for="(item, index) in roofTypeList" :key="index"
                                        :name="index" class="radio-group-item">{{
                                            item }}</van-radio>
                                </van-radio-group>
                            </div>
                        </div>
                        <div class="roofType">
                            <div class="title">
                                <span class="radio-name">每月电费</span>
                                <div class="errShow" v-show="!isFirstInput && !info.monthlyElectricity">请至少选择一项</div>
                            </div>

                            <div class="option">
                                <van-radio-group v-model="value5" direction="horizontal"
                                    @change="change($event, 'monthlyElectricity')">
                                    <van-radio icon-size="18px" v-for="(item, index) in monthlyElectricityList"
                                        :key="index" :name="index" class="radio-group-item">{{ item
                                        }}</van-radio>
                                </van-radio-group>
                            </div>
                        </div>
                        <div class="roofType">
                            <div class="title">
                                <span class="radio-name">空调使用需求</span>
                                <div class="errShow" v-show="!isFirstInput && !info.airconditionDemand">请至少选择一项</div>
                            </div>

                            <div class="option">
                                <van-radio-group v-model="value6" direction="horizontal"
                                    @change="change($event, 'airconditionDemand')">
                                    <van-radio icon-size="18px" v-for="(item, index) in airconditionDemandList"
                                        :key="index" :name="index" class="radio-group-item">{{ item
                                        }}</van-radio>
                                </van-radio-group>
                            </div>
                        </div>
                        <div class="roofType">
                            <div class="title">
                                <span class="radio-name">空调使用习惯</span>
                                <div class="errShow" v-show="!isFirstInput && !info.airconditionHabits">请至少选择一项</div>
                            </div>

                            <div class="option">
                                <van-radio-group v-model="value7" direction="horizontal"
                                    @change="change($event, 'airconditionHabits')">
                                    <van-radio icon-size="18px" v-for="(item, index) in airconditionHabits" :key="index"
                                        :name="index" class="radio-group-item">{{ item }}</van-radio>
                                </van-radio-group>
                            </div>
                        </div>

                    </div>
                </van-form>
                <div style="margin-top: 30px;padding: 0 22px">
                    <div class="subit" style="font-size: 12px;">
                        <van-checkbox icon-size="16px" v-model="agreeProtocal"></van-checkbox>
                        <!-- <van-radio class="radio-group-item">{{ item }}</van-radio> -->
                        <span class="protocal-text">下次自动填写，阅读并同意</span>
                        <span style="color: #267EFF;cursor: pointer;" @click="showPower = true">《授权书》</span>
                    </div>
                    <div class="submit" @click="submit">
                        <span class="proposal-quotation">立刻提交</span>
                    </div>
                    <!-- <van-button round block type="primary"  @click="submit">
            提交
          </van-button> -->
                </div>

            </div>
        </div>
        <div class="img-list" @click="preventTouch">
            <!-- <div class="card-list">
        <div class="first-card-container">
          <div class="card-title-header"><span>格力零碳舒爽家</span></div>
          <div class="card-image">
            <image src="" />
          </div>
          <div class="card-content">
            <div class="card-content-item">
              <div>
                <van-row>
                  <van-col span="14">span: 8</van-col>
                  <van-col span="10">span: 8</van-col>
                </van-row>
              </div>
            </div>
            <div class="card-content-item"></div>
            <div class="card-content-item"></div>
          </div>
        </div>
      </div> -->
            <!-- <img class="first-img" src="../assets/two.png" alt="">
      <img class="without-bg second-img" src="../assets/guangfu.png" alt="">
      <img class="without-bg" src="../assets/rouchu.png" alt="">
      <img class="without-bg" src="../assets/gaoxiaoguangfu.png" alt="">
      <img class="without-bg" src="../assets/greeApp.png" alt=""> -->

            <img class="first-img" src="../assets/new2.jpg" alt="">
            <img class="without-bg second-img" src="../assets/new3.jpg" alt="">
            <img class="without-bg" src="../assets/new4.jpg" alt="">
            <img class="without-bg" src="../assets/new5.jpg" alt="">
            <!-- <img class="without-bg" src="../assets/greeApp.png" alt=""> -->
            <!-- <div class="desc-item">
        <div><span class="desc-item-title">格力光储空套餐</span></div>
        <div class="block-area-list-container">
          <div class="flex-layout">
            <div class="desc-item-block-name">
              <div class="desc-item-block-name-container"><span>和光系列</span></div>
            </div>
          </div>
          <div v-for="item in Math.ceil(part1length / 2)" :key="item" :name="item" class="block-containers">
            <van-row gutter="20">
              <van-col span="12">
                <BlockArea :value="blockDatas[item - 1]"></BlockArea>
              </van-col>
              <van-col v-if="item < blockDatas.length" span="12" class="left-border">
                <BlockArea :value="blockDatas[item]"></BlockArea>
              </van-col>
            </van-row>
          </div>
        </div>
        <div class="block-area-list-container">
          <div class="flex-layout">
            <div class="desc-item-block-name">
              <div class="desc-item-block-name-container"><span>向阳系列</span></div>
            </div>
          </div>

          <div v-for="item in Math.ceil(block2Datas.length / 2)" :key="item" :name="item" class="block-containers">
            <van-row gutter="20">
              <van-col span="12">
                <BlockArea :value="block2Datas[item - 1]"></BlockArea>
              </van-col>
              <van-col v-if="item < block2Datas.length" span="12" class="left-border">
                <BlockArea v-if="item < block2Datas.length" :value="block2Datas[item]"></BlockArea>
              </van-col>
            </van-row>
          </div>
        </div>
        <div class="block-area-list-container">
          <div class="flex-layout">
            <div class="desc-item-block-name">
              <div class="desc-item-block-name-container"><span>耀曙系列</span></div>
            </div>
          </div>

          <div v-for="item in Math.ceil(block3Datas.length / 2)" :key="item" :name="item" class="block-containers">
            <van-row gutter="20">
              <van-col span="12">
                <BlockArea :value="block3Datas[item - 1]"></BlockArea>
              </van-col>
              <van-col v-if="item < block3Datas.length" span="12" class="left-border">
                <BlockArea v-if="item < block3Datas.length" :value="block3Datas[item]"></BlockArea>
              </van-col>
            </van-row>
          </div>
        </div>
        <div class="block-desc-text">
          <span>说明：具体设计以实际设计安装为准。此处建议零售价仅作示意，具体以商务报价为准。</span>
        </div>
      </div> -->
            <!-- <img src="../assets/taocan1.png" style="width:90%" alt="">
      <img src="../assets/guankong.png" style="width:90%" alt="">
      <img src="../assets/guangchu.png" style="width:90%" alt=""> -->
            <!-- <img src="../assets/guangfu.png" style="width:90%" alt=""> -->
        </div>
        <div class="footer">
            <div class="more">
                <div class="title1">获取更多信息</div>
                <div class="title2">tel: 0756-2697854</div>
                <!-- <div class="title2">TEL 16675690332</div> -->
                <div class="title-mail">mail: sjbxny-01@cn.gree.com</div>
                <div class="title3">http: //www.gree.com.cn</div>
                <!-- <div class="title-mail"><span>mail:  sjbxny-01@cn.</span>&nbsp;<span>gree.</span>&nbsp;<span>com</span> </div>
        <div class="title3"><span>http: //www.</span>&nbsp;<span>gree.</span>&nbsp;<span>com.</span>&nbsp;<span>cn</span></div> -->
            </div>

        </div>
        <div class="btn">
            <div @click="goToFormArea">
                <div class="btn-con">
                    <img src="../assets/edit.png" alt="">
                    <span class="proposal-quotation">免费获取方案和报价</span>
                </div>
            </div>

            <div class="log"><span class="name">格力电器股份有限公司 |</span><span class="statement"
                    @click="isShowDeclaration = true">《个人信息保护申明》</span></div>

        </div>

        <van-popup v-model="showArea" position="bottom">
            <van-area :area-list="areaList" value="110101" @confirm="onConfirm" @cancel="showArea = false" />
        </van-popup>

        <!--授权书弹框  -->
        <div class="power-popup">
            <van-popup style="max-width: 80%; width: 440px; border-radius: 9px;" closeable v-model="showPower">
                <div class="popup-class">
                    <Power style="width: 90%;margin:0 auto;"></Power>
                </div>
            </van-popup>
        </div>
        <!--个人信息保护申明弹框  -->
        <div class="power-popup">
            <van-popup style="max-width: 80%; width: 440px; border-radius: 9px;" closeable v-model="isShowDeclaration">
                <div class="declaration-popup">
                    <Declaration style="width: 90%;margin:0 auto;" @closepopup="isShowDeclaration = false">
                    </Declaration>
                </div>
            </van-popup>
        </div>

    </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import md5 from 'md5';
import { Area, Button, Cell, CellGroup, Checkbox, CheckboxGroup, Col, Field, Form, Image, Lazyload, Popup, Radio, RadioGroup, Row, Swipe, SwipeItem, Toast } from 'vant';
import Vue from 'vue';
import wx from 'weixin-js-sdk';
import { app, url } from '../../config/index';
import { encrypt } from '../../util/index';
import BlockArea from './BlockArea.vue';
import Declaration from './Declaration.vue';
import Power from './powerAttorney.vue';
Vue.use(Lazyload);
let { appId, appKey } = app;
// let isFirstInput = false

// console.log(areaList);
export default {
    name: 'HelloWorld',
    components: {
        [Form.name]: Form,
        [Field.name]: Field,
        [Area.name]: Area,
        [Popup.name]: Popup,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [Button.name]: Button,
        [Toast.name]: Toast,
        [Col.name]: Col,
        [Row.name]: Row,
        [BlockArea.name]: BlockArea,
        [Image.name]: Image,
        [Power.name]: Power,
        [Declaration.name]: Declaration,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem

    },
    data() {
        return {
            // images: [require('../assets/swipe2.png'), require('../assets/swipe.png'), require('../assets/swipe4.png'), require('../assets/swipe3.png')],
            images: [require('../assets/new1.jpg')],
            show: false,
            swipeShow: true,
            info: {
                name: '',
                phone: '',
                province: '',
                city: '',
                area: '',
                propertyType: '',
                floor: '',
                floorArea: '',
                roofType: '',
                monthlyElectricity: '',
                airconditionDemand: '',
                airconditionHabits: ''
            },
            isFirstInput: '',
            value1: -1,
            value2: -1,
            value3: -1,
            value4: -1,
            value5: -1,
            value6: -1,
            value7: -1,
            showArea: false,
            areaList: areaList,
            radio: '1',
            value: '',
            propertyTypeList: ['独栋别墅', '联排别墅', '叠拼别墅'],
            floorList: ['二层', '三层', '四层', '五层'],
            floorAreaList: ['200m²', '250m²', '300m²', '350m²', '400m²'],
            roofTypeList: ['单坡', '双坡', '四坡', '折腰', '平屋面'],
            monthlyElectricityList: ['低于1500元/月', '1500-3000元/月', '3000元/月以上'],
            airconditionDemandList: ['制冷', '制热', '制冷及制热'],
            airconditionHabits: ['使用时开', '夜间开', '24小时全开'],
            inputvalue: "",
            selectValue: '',
            errMessage: '',
            isHasNullData: '',
            errStatus: false,
            errPhoneStatus: false,
            floorAreaVal: '',
            agreeProtocal: false,
            // 套餐列表数据
            blockDatas: [
                {
                    top: {
                        leftList: ['6kW+', '5kWh'],
                        rightList: [
                            { left: '·光伏组件', right: '6kW' },
                            { left: '·家庭级智能柔储', right: '5kWh' },
                            { left: '·“格力+”APP', right: '1套' },
                        ]
                    },
                    bottom: {
                        area: 25,
                        price: 70000
                    }
                },
                {
                    top: {
                        leftList: ['6kW+', '10kWh'],
                        rightList: [
                            { left: '·光伏组件', right: '6kW' },
                            { left: '·家庭级智能柔储', right: '10kWh' },
                            { left: '·“格力+”APP', right: '1套' },
                        ]
                    },
                    bottom: {
                        area: 25,
                        price: 110000
                    }
                }
            ],
            block2Datas: [
                {
                    top: {
                        leftList: ['6kW+', '5p'],
                        rightList: [
                            { left: '·光伏组件', right: '6kW' },
                            { left: '·光伏多联机', right: '1套' },
                            { left: '·“格力+”APP', right: '1套' },
                        ]
                    },
                    bottom: {
                        area: 30,
                        coldArea: '75-105',
                        price: 76000
                    }
                },
                {
                    top: {
                        leftList: ['6kW+', '7p'],
                        rightList: [
                            { left: '·光伏组件', right: '6kW' },
                            { left: '·光伏多联机', right: '1套' },
                            { left: '·“格力+”APP', right: '1套' },
                        ]
                    },
                    bottom: {
                        area: 30,
                        coldArea: '105-165',
                        price: 86000
                    }
                }
            ],
            block3Datas: [
                {
                    top: {
                        leftList: ['6kW+', '10kWh'],
                        rightList: [
                            { left: '·光伏组件', right: '6kW' },
                            { left: '·家庭级智能柔储', right: '10kWh' },
                            { left: '·光伏家装多联机', right: '1台' },
                            { left: '·“格力+”APP', right: '1套' },
                        ]
                    },
                    bottom: {
                        area: 30,
                        coldArea: '75-105',
                        price: 156000
                    }
                },
                {
                    top: {
                        leftList: ['6kW+', '10kWh'],
                        rightList: [
                            { left: '·光伏组件', right: '6kW' },
                            { left: '·家庭级智能柔储', right: '10kWh' },
                            { left: '·光伏家装多联机', right: '1台' },
                            { left: '·“格力+”APP', right: '1套' },
                        ]
                    },
                    bottom: {
                        area: 30,
                        coldArea: '85-165',
                        price: 158000
                    }
                }
            ],
            showPower: false,
            isShowDeclaration: false
        }
    },
    computed: {
        part1length() {
            console.log(this.blockDatas.length);
            return this.blockDatas.length;
        }
    },
    mounted() {
        setTimeout(() => {
            this.show = true;
        }, 200)
    },
    created() {
        this.isFirstInput = true;
        // this.$refs.swipe.resize();
        this.ShareByWx()
    },
    methods: {
        ShareByWx() {
            const urlparam = window.location.href.split('#')[0]
            console.log("url", urlparam);
            const currentUrl = url + '/lsdf-survey/submit/jsapi-signature'
            //const currentUrl = "http://127.0.0.1:3000/getInfo"
            // const url = `http://scanusertest.gree.com/wxmp/wx/jsapi/signature`
            // const url = `http://scanusertest.gree.com/token?access_url=${currentUrl}`
            const t = parseInt(new Date().getTime() / 1000).toString();
            let msc = "";
            let value = md5(`appId=${appId}&appKey=${appKey}&mac=${msc}&mid=${msc}&time=${t}`);
            let sign = value.toUpperCase();
            let tok = `appId=${appId};mac=${msc};mid=${msc};time=${t};sign=${sign}`
            let token = this.encode(tok);
            console.log(sign, token);
            this.$axios({
                url: currentUrl,
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                params: { url: urlparam }
            }).then(function (res) {
                console.log(res);
                // const code = res.data.code;
                const data = res.data.data;
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: 'wxf36da9dc768d09c8', // 必填，公众号的唯一标识
                    timestamp: Number(data.timestamp), // 必填，生成签名的时间戳
                    nonceStr: data.noncestr, // 必填，生成签名的随机串
                    signature: data.signature,// 必填，签名
                    jsApiList: [
                        'updateTimelineShareData',    //分享到朋友圈
                        'updateAppMessageShareData',  //分享给朋友
                    ]
                });
                wx.ready(function (res) {
                    //需在用户可能点击分享按钮前就先调用
                    wx.updateTimelineShareData({
                        title: '格力光储空 用空调 不用电费', // 分享标题
                        link: 'https://testnlu.gree.com/lsdf-survey', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: 'https://testnlu.gree.com/lsdf-survey/static/img/swipe2.png', // 分享图标
                        success: function () {
                            console.log("分享成功");
                        },
                        fail: function (err) {
                            console.log("shibai", err);
                        }
                    })
                    wx.updateAppMessageShareData({
                        title: '格力光储空 用空调 不用电费', // 分享标题
                        link: 'https://testnlu.gree.com/lsdf-survey', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: 'https://testnlu.gree.com/lsdf-survey/static/img/swipe2.png', // 分享图标
                        success: function () {
                            console.log("分享成功");
                        },
                        fail: function (err) {
                            console.log("shibai", err);
                        }
                    })
                    console.log(res);
                });
                wx.error((err) => {
                    wx.updateTimelineShareData({
                        title: '格力光储空 用空调 不用电费', // 分享标题
                        link: 'https://testnlu.gree.com/lsdf-survey', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: 'https://testnlu.gree.com/lsdf-survey/static/img/swipe2.png', // 分享图标
                        success: function () {
                            console.log("分享成功");
                        },
                        fail: function (err) {
                            console.log("shibai", err);
                        }
                    })
                    wx.updateAppMessageShareData({
                        title: '格力光储空 用空调 不用电费', // 分享标题
                        link: 'https://testnlu.gree.com/lsdf-survey', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: 'https://testnlu.gree.com/lsdf-survey/static/img/swipe2.png', // 分享图标
                        success: function () {
                            console.log("分享成功");
                        },
                        fail: function (err) {
                            console.log("shibai", err);
                        }
                    })
                    console.error(err);
                })

            }).catch(function (err) {
                console.log(err);
                Toast.fail('网络异常');
            })

        },
        getLastedResource() {
            this.removeOldIconfontFile();
            // 重新获取一下iconfont.css 以保证最新的图标文件能被加载
            var css = document.createElement("link");
            css.rel = "stylesheet";
            css.href = `${process.env.BASE_URL}iconfont/iconfont.css?t=${Date.now()}`; // 图标文件
            document.head.appendChild(css);
        },
        removeOldIconfontFile() {
            var filename = 'iconfont/iconfont.css';  //移除引入的文件名
            var targetelement = "link";
            var targetattr = "href";
            var allsuspects = document.head.getElementsByTagName(targetelement)
            for (var i = allsuspects.length; i >= 0; i--) {
                if (allsuspects[i] && allsuspects[i].getAttribute(targetattr) != null && allsuspects[i].getAttribute(targetattr).indexOf(filename) != -1) {
                    allsuspects[i].parentNode.removeChild(allsuspects[i])
                }
            }
        },
        rulesFunc() {
            if (!this.info.name || this.info.phone) {
                this.isHasNullData = true;
            } else if (!this.selectValue) {
                this.errMessage = "请选择省市区"
                this.isHasNullData = true;
            } else if (!this.info.propertyType || !this.info.floor || !this.info.floorArea || !this.info.roofType || !this.info.monthlyElectricity || !this.info.airconditionDemand || !this.info.airconditionHabits) {
                this.errMessage = "请至少选择一项"
                this.isHasNullData = true;
            }
        },
        validName(value) {
            var reg = /^[\u4e00-\u9fa5]{1,4}$/;
            if (reg.test(value)) {
                return true;
            }
            return false;
        },
        validPhone(value) {
            var reg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
            if (reg.test(value)) {
                return true;
            }
            return false;
        },
        nameInput(e) {
            const isValid = this.validName(e);
            if (isValid) {
                this.errStatus = false
                this.info.name = e
            } else {
                this.errStatus = true
            }
            // var reg = /[^\u4e00-\u9fa5]/;
            // if (e && e.match(reg)) {
            //   this.errStatus = true
            // } else {
            //   this.errStatus = false
            //   this.info.name = e
            // }
        },
        phoneInput(e) {
            const isValid = this.validPhone(e);
            if (isValid) {
                this.errPhoneStatus = false
                this.info.phone = e;
            } else {
                this.errPhoneStatus = true;
            }
            // var reg = /^1[0-9]{10}$/;
            // if (e && !e.match(reg)) {
            //   this.errPhoneStatus = true;
            // } else {
            //   this.errPhoneStatus = false
            //   this.info.phone = e;
            // }
        },
        onConfirm(e) {
            console.log(e);
            this.selectValue = e
                .filter((item) => !!item)
                .map((item) => item.name)
                .join('/');
            this.info.province = e[0].name || "";
            this.info.city = e[1].name || "";
            this.info.area = e[2].name || "";
            this.showArea = false;
        },

        //字符串转base64
        encode(str) {
            // 对字符串进行编码
            var encode = encodeURI(str);
            // 对编码的字符串转化base64
            var base64 = btoa(encode);
            return base64;

        },
        isValidNameAndPhone() {
            const info = this.info;
            const isValidName = this.validName(info.name);
            const isValidPhone = this.validPhone(info.phone);
            if (!isValidName || !isValidPhone) {
                return false;
            }
            return true;
        },
        submit() {
            this.rulesFunc();
            this.isFirstInput = false;
            console.log(JSON.stringify(this.info));
            for (var key in this.info) {
                if (!this.info[key]) return;
            }
            console.log(JSON.stringify(this.info));
            // 还需要检查是否符合规则【姓名、电话】
            if (!this.isValidNameAndPhone()) {
                // 姓名和电话校验未通过
                return;
            }
            let sendMessage = encrypt(JSON.stringify(this.info));
            const t = parseInt(new Date().getTime() / 1000).toString();
            let msc = "";
            let value = md5(`appId=${appId}&appKey=${appKey}&mac=${msc}&mid=${msc}&time=${t}`);
            let sign = value.toUpperCase();
            let tok = `appId=${appId};mac=${msc};mid=${msc};time=${t};sign=${sign}`
            let token = this.encode(tok);
            console.log(sendMessage, sign, token);
            this.$axios({
                method: "post",//指定请求方式
                url: `${url}/lsdf-survey/submit`,
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                data: {
                    data: sendMessage
                }
            }).then(function (res) {
                console.log(res);
                const code = res.data.code;
                if (code === 200) {
                    Toast.success('提交成功')
                } else {
                    Toast.fail(res.data.info);
                }
            }).catch(function (err) {
                console.log(err);
                Toast.fail('网络异常');
            })
        },

        inputValueChange(e, type) {
            console.log(type);
            if (type == "floorArea") {
                this.info.floorArea = e;
                console.log(this.floorAreaVal);
            } else if (type == 'floor') {
                this.info.floor = e;

            }


        },
        onSubmit() {
        },
        change(e, type) {
            console.log('%%%%%%%%%%%%%this.inputvalue', this.inputvalue);
            console.log(e, type);
            switch (type) {
                case 'propertyType':
                    this.value1 = e;
                    this.info.propertyType = this.propertyTypeList[e];
                    break;
                case 'floor':
                    this.value2 = e;
                    if (e !== "other") {
                        this.inputvalue = ""
                        this.info.floor = this.floorList[e];
                    }

                    break;
                case 'floorArea':
                    this.value3 = e;
                    if (e !== "other") {
                        this.floorAreaVal = ""
                        this.info.floorArea = this.floorAreaList[e];
                    }
                    break;
                case 'roofType':
                    this.value4 = e;
                    this.info.roofType = this.roofTypeList[e];
                    break;
                case 'monthlyElectricity':
                    this.value5 = e;
                    this.info.monthlyElectricity = this.monthlyElectricityList[e];
                    break;
                case 'airconditionDemand':
                    this.value6 = e;
                    this.info.airconditionDemand = this.airconditionDemandList[e];
                    break;
                case 'airconditionHabits':
                    this.value7 = e;
                    this.info.airconditionHabits = this.airconditionHabits[e];
                    break;
                default:
                    break;
            }


        },
        goToFormArea() {
            document.querySelector('#anchor').scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
        },
        preventTouch(e) {
            e.stopPropagation();
            e.preventDefault();
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
// .van-radio__icon--checked .van-icon{

// }
.carousel {
    /* the percentages below are for a 4:3 landscape photo(1600x1200) */
    height: 100%;

}

.power-popup .van-icon {
    color: #000;
    font-size: 17px;
    position: absolute;
    top: 7px;
    right: 5px;
}

.declaration-popup {
    overflow: hidden;
    height: 400px;
    // max-width: 400px;
    padding-top: 18px;
}

.popup-class {
    overflow: hidden;
    height: 400px;
    // max-width: 400px;
    padding: 18px 0;
}

.form .van-cell {
    padding: 13px 16px;
}

.van-radio__icon .van-icon {
    background-color: #F6F6F6;
}

.van-checkbox__icon--round .van-icon {
    background-color: #F6F6F6;
}

.van-radio__icon--checked .van-icon {
    color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
}

.van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
}
</style>


<style lang='less' scoped>
.container ::v-deep .van-radio__label {
    font-size: 14px;
}

.van-cell ::v-deep .van-cell__title.van-field__label {
    // font-weight: 700;
    color: #383a3e;
    letter-spacing: 1px;
}

.block-desc-text {
    color: rgba(0, 0, 0, 0.7);
    font-size: 8px;
    // font-size: 12px;
    margin: 8px 30px;
    text-align: left;
}

.desc-item {
    width: 100%;
    text-align: center;
    margin-top: 50px;
}

.desc-item-title {
    font-family: PingFang SC Heavy, PingFang SC Heavy-Heavy;
    color: #000000;
    letter-spacing: 1px;
    font-weight: bold;
    font-size: 22px;
}

.flex-layout {
    display: flex;
    justify-content: center;
    align-items: center;
}


.card-list {}

.first-card-container {
    width: 100%;
}

.card-title-header {
    font-size: 22px;
    color: #000000;
    font-family: PingFang SC Heavy, PingFang SC Heavy-Heavy;
    letter-spacing: 1px;
    font-weight: bold;
}

.card-image {}

.card-content {}

.card-content-item {}

.desc-item-block-name {
    position: relative;
    z-index: 11;
    font-size: 16px;
    font-family: PingFang SC Heavy, PingFang SC Heavy-Heavy;
    font-weight: bold;

    &-container {
        padding: 6px 20px;
        background: #212222;
        color: #fff;
        position: relative;
        z-index: 12;
    }

    &::after {
        content: '';
        position: absolute;
        background-color: #56d09b;
        width: 100%;
        height: 100%;
        left: 5px;
        top: -5px;
        z-index: 1;
    }
}

.block-containers {
    border: 1px solid #b0b0b0;
    // margin: 15px 30px;
    margin: 15px 15px 0;
    // margin: 15px 30px 0;
    padding: 10px;
    border-radius: 6px;
}

.block-containers .van-row {
    display: flex;
}

.block-area-list-container {
    margin-top: 28px;
}

.left-border {
    border-left: 1px solid #B0B0B0;
}

// .block-item {
//   text-align: left;

//   & .top-part {
//     display: flex;
//     flex-wrap: nowrap;
//     flex-direction: row;

//     & .top-left-part {
//       flex: 3;
//       color: #000000;
//       font-family: PingFang SC Heavy, PingFang SC Heavy-Heavy;
//       font-weight: bold;
//       font-size: 16px;
//     }

//     & .top-right-part {
//       flex: 7;
//       color: #000000;
//       font-family: PingFang SC Bold, PingFang SC Bold-Bold;
//       font-weight: 700;
//       letter-spacing: 1px;
//       font-size: 12px;
//       line-height: 24px;
//     }
//   }
// }

// .top-left-part-desc {
//   font-size: 12px;
// }

// .right-part-list-item {
//   display: flex;
//   flex-flow: row nowrap;

//   & .right-part-item-title {
//     flex: 7;
//   }

//   & .right-part-item-value {
//     flex: 3;
//   }
// }

// .bottom-part {
//   display: flex;
//   flex-flow: row nowrap;
//   margin-top: 18px;
//   align-items: flex-end;
// }

// .bottom-left-part {
//   font-size: 12px;
//   font-weight: bold;
// }

// .area-text {
//   font-size: 18px;
//   font-weight: 700;
// }

// .bottom-right-part {
//   flex: 1;
//   text-align: right;
//   font-size: 12px;
//   font-weight: bold;
// }

// .price {
//   font-family: PingFang SC Bold, PingFang SC Bold-Bold;
//   font-weight: 700;
//   color: #3B9469;
//   letter-spacing: 1px;
//   font-size: 22px;
// }

.protocal-text {
    margin-left: 4px;
}

.container {
    ::v-deep .radio-group-item {
        margin-bottom: 20px;
    }
}

.proposal-quotation {
    cursor: pointer;
    color: #704915;
    margin-left: 6px;
    font-weight: 700;
}

.errShow {
    color: #ee0a24;

}

.head {
    width: 100%;

    .v3 img,
    .v4 img {
        width: 20px;
        height: 20px;
        padding-right: 10px;
    }

    .v1 {
        font-size: 35px;
        font-weight: bold;
        padding-top: 50px;
        padding-bottom: 12px;
    }

    .v2 {
        font-size: 15px;
        padding-bottom: 30px;
    }

    .v3 span {
        font-size: 15px;
        padding-bottom: 17px;
    }

    .v4 span {
        font-size: 15px;
    }

    .v3 {
        display: flex;

    }

    .v4 {
        display: flex;
    }

}

// .otherInput {

// }

.form {
    // padding-top: 18px;
    background-color: #E2E6ED;
    color: #000000;

}

.otherInput {
    background-color: transparent;
    border-bottom: 1px solid;
    padding: 0 !important;
    width: 100px;
    line-height: 17px;
    margin-left: 6px;
}

.other {
    display: flex;
    align-items: center;

    span {
        // width: 50px;
    }

}

.radio-name::after {
    content: '*';
    color: red;
    font-size: 18px;
    margin-left: 2px;
}

.subit {
    font-size: 17px;
    padding-top: 21px;
    padding-bottom: 6px;
    // padding-bottom: 12px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.radio {
    padding-left: 22px;
    padding-top: 20px;
}

.submit {
    // margin-top: 10px;
    background-image: url('../assets/btn.png');
    padding: 12px;
    display: flex;
    justify-content: center;
    color: #7E5920;
    font-size: 19px;
    // font-size: 24px;
    font-weight: 600;
    // font-size: 27px;
    background-size: 100% 100%;
    // width: 85%;
    cursor: pointer;
    margin: 0 auto;
}

.btn-con {
    margin-top: 24px;
    background-image: url('../assets/footer.png');
    background-size: 100% 100%;
    padding: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 19px;
    // font-size: 24px;
    // font-size: 27px;
    cursor: pointer;

    img {
        width: 20px;
        height: 20px;
        // width: 28px;
        // height: 28px;
    }
}

.title {
    // padding-top: 22px;
    padding-top: 18px;
    padding-bottom: 20px;

}

.radio-name {
    font-size: 18px;
    // font-size: 20px;
    font-weight: 600
}

// .title:first-child{
//   padding-top: 0;
// }

.without-bg {
    // background-color: #fff;
    //  background-color: #2c3e50;
}

.container {
    position: relative;
    max-width: 550px;
    margin: 0 auto;
    //background-color: #E2E6ED;
}

.img-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #e2e6ed;

    img {
        // padding-top: 36px;
        // padding-top: 50px;
    }

    .first-img {
        background-color: #fff;
        background: linear-gradient(180deg, transparent 0%, transparent 30%, #fff 30%, #fff 100%);
        padding-top: 0;
        margin-top: 50px;
        // background: #e2e6ed;
    }

    .second-img {
        // padding-top: 36px;
    }
}


.more {
    border: 1px solid #099fec;
    width: 86%;
    margin: 0 auto;
    margin-top: 48px;
    background-color: #e6e6e650;
    border-radius: 5px;
    // color: #099fec;
}

img {
    width: 100%;
}

::v-deep .van-cell--required {
    &:before {
        content: ''
    }

    .van-cell__title.van-field__label {
        span {
            position: relative;

            &:before {
                position: absolute;
                right: -8px;
                color: #ee0a24;
                font-size: 14px;
                content: '*';
            }
        }
    }
}

.title1 {
    font-size: 16px;
    // font-size: 23px;
    padding-top: 21px;
    padding-bottom: 5px;
    text-align: center;
    font-family: PingFang SC Medium, PingFang SC Medium-Medium;
    font-weight: 800;
    color: #099fec;
    letter-spacing: 1px;
}

.title2 {
    font-size: 16px;
    font-weight: 800;
    // font-size: 27px;
    //padding-top: 14px;
    // padding-top: 23px;
    text-align: center;
    font-family: PingFang SC Heavy, PingFang SC Heavy-Heavy;
    font-weight: 800;
    color: #099fec;
    letter-spacing: 1px;
}

// .title{
//   font-size: 19px;
//   font-weight: 800;
//   // font-size: 27px;
//   //padding-top: 14px;
//   // padding-top: 23px;
//   text-align: center;
//   font-family: PingFang SC Heavy, PingFang SC Heavy-Heavy;
//   font-weight: 800;
//   color: #099fec;
//   letter-spacing: 1px;
// }
.title-mail {
    font-size: 16px;
    // font-weight: 800;
    text-align: center;
    font-family: PingFang SC Heavy, PingFang SC Heavy-Heavy;
    font-weight: 800;
    color: #099fec;
    letter-spacing: 1px;
    padding-top: 3px;

}

.log {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 12px;
    // padding-bottom: 24px;

    .name {
        color: rgba(56, 58, 62, 0.7);
    }
}

.statement {
    color: #267EFF;
    cursor: pointer;
}

.btn {
    // position: fixed;
    // bottom: 0;
    // background-color: #E2E6ED;
    max-width: 550px;
    width: 100%;
    position: sticky;
    bottom: 0;
    background: #e2e6ed;
    z-index: 1111;
}

.footer {
    // padding-bottom: 200px;
}

.title3 {
    font-size: 16px;
    // font-size: 23px;
    text-align: center;
    padding-bottom: 21px;
    font-family: PingFang SC Medium, PingFang SC Medium-Medium;
    font-weight: 800;
    color: #099fec;
    letter-spacing: 1px;
    padding-top: 5px;
}
</style>
